export default __webpack_public_path__ + "static/O0319-28ac724749dfceb6be945ea8fa06c79e.png";